import { Pipe, PipeTransform } from '@angular/core'
import { EstimateBalance } from '@mmx/shared'

import { balanceCptCodes } from '../balance-utils'

@Pipe({
  name: 'balanceCpts',
  standalone: true,
})
export class BalanceCptsPipe implements PipeTransform {
  transform(value: EstimateBalance | null | undefined): string[] {
    return balanceCptCodes(value)
  }
}
